var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex justify-start screen-control-avatar-grouped-cell" },
    [
      _vm.useAvatar
        ? _c("kh-avatar-group", {
            staticClass: "d-flex",
            attrs: {
              "label-render-method": _vm.initialNameMethod,
              color: "secondary",
            },
            model: {
              value: _vm.avatarUsers,
              callback: function ($$v) {
                _vm.avatarUsers = $$v
              },
              expression: "avatarUsers",
            },
          })
        : _c(
            "div",
            { staticClass: "screen-control-room-staff-animation" },
            [
              _c("kh-text", {
                directives: [
                  {
                    name: "kh-animation",
                    rawName: "v-kh-animation",
                    value: _vm.animationProps,
                    expression: "animationProps",
                  },
                ],
                attrs: { text: _vm.userNames },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }